import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { partition } from 'ramda';
import { deleteGroupMember } from 'products/nomad_insurance/state/groupMembers';
import { updatePlanholderInfo } from 'products/nomad_insurance/state/planholder';
import { addonChange } from 'products/nomad_insurance/views/Purchase/steps/Coverage/state';
import { SAFETYWING_ADDONS as ADDONS } from 'components/Addon/consts';
import BaseModal from 'products/nomad_insurance/components/BaseModal';
import Button from 'products/nomad_insurance/components/Button';
import { sizes } from 'style';

const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;

  @media ${sizes.desktop} {
    flex-direction: row;
    justify-content: flex-end;
  }
`;

const USGroupMemberWarning = ({ groupMembers, isOpen, onClose, callback }) => {
  const dispatch = useDispatch();
  const { addons } = useSelector(
    (state) => state.nomadInsurance.purchaseInsurance.coverage
  );
  const USCoverageAddon = ADDONS.find((addon) => addon.value === 'USA_COVERAGE');
  const hasUSCoverage = addons.find((addon) => addon.id === USCoverageAddon.id);

  const onRemoveGroupMembers = async () => {
    const [groupMembersToDelete, newGroupMembers] = partition(
      (member) => member.citizenshipCountry === 'US' || member.citizenship === 'US',
      groupMembers
    );
    groupMembersToDelete.forEach((member) =>
      dispatch(deleteGroupMember(member.groupMemberID))
    );
    dispatch(updatePlanholderInfo({ groupMembers: newGroupMembers }));
    await dispatch(addonChange(USCoverageAddon));
    onClose();
    if (callback) callback();
  };

  const onRemoveUSCoverage = async () => {
    if (hasUSCoverage) {
      await dispatch(addonChange(USCoverageAddon));
    }
    onClose();
    if (callback) callback();
  };

  return (
    <BaseModal
      heading="You cannot purchase US coverage"
      isOpen={isOpen}
      onClose={onClose}
    >
      US coverage add-on is only available for non-US citizens. As such, while you have a
      group member that is a US citizen, you will not be able to purchase US coverage. To
      purchase US coverage, you must remove group member(s) with US citizenship.
      <Buttons>
        <Button variant="textOnly" onClick={onRemoveUSCoverage}>
          Don't purchase US coverage
        </Button>
        <Button color="fuzzyWuzzyBrown" onClick={onRemoveGroupMembers}>
          Remove group member(s)
        </Button>
      </Buttons>
    </BaseModal>
  );
};

USGroupMemberWarning.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  groupMembers: PropTypes.array.isRequired,
  callback: PropTypes.func
};

export default USGroupMemberWarning;
